/**
 * @generated SignedSource<<f5779dfc7e8da2c1f18e09902567e3f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type DemoFunctionalityContextDebugDataResetSubscription$variables = Record<PropertyKey, never>;
export type DemoFunctionalityContextDebugDataResetSubscription$data = {
  readonly debugDataReset: string | null | undefined;
};
export type DemoFunctionalityContextDebugDataResetSubscription = {
  response: DemoFunctionalityContextDebugDataResetSubscription$data;
  variables: DemoFunctionalityContextDebugDataResetSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "debugDataReset",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DemoFunctionalityContextDebugDataResetSubscription",
    "selections": (v0/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DemoFunctionalityContextDebugDataResetSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "71161e97068141689d006e7ef74a5cf7",
    "id": null,
    "metadata": {},
    "name": "DemoFunctionalityContextDebugDataResetSubscription",
    "operationKind": "subscription",
    "text": "subscription DemoFunctionalityContextDebugDataResetSubscription {\n  debugDataReset\n}\n"
  }
};
})();

(node as any).hash = "620c888a7e0eb3615dab90be2bfc0d76";

export default node;
